import PhoneNumber from 'awesome-phonenumber';
import {
    getEoriValidation,
    getExactLengthValidation,
    getRequiredMessage,
} from 'views/declarations/utils/validation-utils';
import * as Yup from 'yup';

export const phoneCountryCodeSchema = () =>
    Yup.string()
        .trim()
        .nullable()
        .test('has-phoneNumber', 'Phone country code is required.', function (value) {
            const { phoneNumber } = this.parent;

            if (!phoneNumber) return true;

            return !!value;
        });

export const phoneNumberSchema = () =>
    Yup.string()
        .nullable()
        .test('has-phoneCountryCode', 'Phone number is required when a country code is selected.', function (value) {
            const { phoneCountryCode } = this.parent;

            if (!phoneCountryCode) return true;

            return !!value;
        })
        .test('valid-phoneNumber', 'Phone number is invalid', function (value) {
            const { phoneCountryCode } = this.parent;

            if (!phoneCountryCode || !value) return true;

            return new PhoneNumber(`${phoneCountryCode}${value}`).isValid();
        });

export const addressSchema = Yup.object({
    addressLine1: Yup.string().trim().nullable().required('Field is required.'),
    addressLine2: Yup.string().trim().nullable(),
    country: Yup.string().trim().nullable().required(getRequiredMessage('country')),
    postCode: Yup.string().trim().nullable().required(getRequiredMessage('postCode')),
    city: Yup.string().trim().nullable().required(getRequiredMessage('city')),
});

export const contactSchema = Yup.object({
    name: Yup.string().trim().nullable().required(getRequiredMessage('contactName')),
    email: Yup.string().trim().nullable().email('Email is invalid.').required(getRequiredMessage('email')),
    phoneCountryCode: phoneCountryCodeSchema(),
    phoneNumber: phoneNumberSchema(),
});

export const generalCustomerSchema = Yup.object({
    referenceCode: getExactLengthValidation('referenceCode', 3).required('Reference code is required.').nullable(),
    eori: getEoriValidation().required('EORI is required.').nullable(),
    name: Yup.string().required('Customer name is required.').nullable(),
    address: addressSchema,
    contact: contactSchema,
    contacts: Yup.array().of(contactSchema).nullable(),
    specialInstructions: Yup.string()
        .nullable()
        .max(999, 'Special instructions should not exceed 999 characters')
        .optional(),
});

export const customerDetailsSchema = Yup.object({
    dutyPayer: Yup.string().required(getRequiredMessage('dutyPayer')).nullable(),
    vatTreatment: Yup.string().required('VAT treatment is required').nullable(),
    confirmedTanUsage: Yup.boolean().nullable(),
    vatExemption: Yup.boolean().nullable(),
    billingName: Yup.string().nullable(),
    billingEmail: Yup.string().nullable().email('Email is invalid.'),
    thirdParty: Yup.string().nullable(),
});

export const dutyVatBillingCustomerSchema = Yup.object({
    customerDetails: customerDetailsSchema,
    // TODO: Not part of the customer payload yet, to be confirmed with the BE
    billingCustomerCode: Yup.string().nullable(),
});

export const getCustomerSchema = () => generalCustomerSchema.concat(dutyVatBillingCustomerSchema);
